import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { firebaseInstance } from './firebase'

export const authInstance = getAuth(firebaseInstance)

if (process.env.REACT_APP_FIREBASE_EMULATORS) {
  connectAuthEmulator(authInstance, 'http://localhost:9099')
}
